<template>
  <div class="datatable-filters">
    <v-menu :close-on-content-click="false" v-model="menu">
      <template v-slot:activator="{ on }">
        <v-btn icon text v-on="on">
          <v-icon class="mdi mdi-filter-variant" />
        </v-btn>
      </template>
      <v-card width="450">
        <v-card-title>
          <h3 class="subtitle-1 font-weight-light">Adicionar filtro</h3>
          <v-spacer />
          <v-btn icon @click="close()">
            <v-icon class="mdi mdi-close" />
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-select
            label="Filtro"
            :items="selectFilters"
            v-model="filterName"
          />
          <template v-if="selectedFilter.name !== ''">
            <v-text-field
              v-if="selectedFilter.type === 'text'"
              v-model="selectedFilter.value"
              label="Valor"
            />
            <v-text-field
              v-if="selectedFilter.type === 'number'"
              v-model.number="selectedFilter.value"
              v-touch="selectedFilter.value"
              :error-messages="valueErrors"
              label="Valor"
            />
            <v-switch
              v-if="selectedFilter.type === 'switch'"
              v-model="selectedFilter.value"
              :label="
                selectedFilter.value
                  ? selectedFilter.options.trueValue || 'Sim'
                  : selectedFilter.options.falseValue || 'Não'
              "
            />
            <v-autocomplete
              v-if="selectedFilter.type === 'select'"
              v-model="selectedFilter.value"
              label="Valor"
              :items="selectedFilter.options"
              item-text="text"
              item-value="value"
              :multiple="selectedFilter.multiple"
              :filter="customFilter"
            />
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="clearFilters()">LIMPAR</v-btn>
          <v-btn
            depressed
            color="secondary"
            @click="addFilter()"
            :disabled="$v.$invalid || selectedFilter.value === ''"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-menu>
    <v-chip
      v-for="(value, name) in addedFilters"
      :key="`filter-${name}`"
      class="mr-2"
      close
      @click:close="removeFilter(name)"
    >
      <b class="mr-1">{{ chipLabel(name) }}:</b>
      {{ chipValue(name, value) }}
    </v-chip>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { numeric } from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  validations() {
    const rules = { selectedFilter: { value: {} } };
    if (this.selectedFilter.type === "number") {
      rules.selectedFilter = {
        value: { numeric },
      };
    }

    return rules;
  },
  props: ["filters", "value"],
  data() {
    return {
      menu: false,
      selectedFilter: {
        name: "",
        type: "",
        label: "",
        value: null,
        multiple: false,
      },
      defaultFilter: {
        name: "",
        type: "",
        label: "",
        value: null,
        multiple: false,
      },
      addedFilters: {},
    };
  },
  mounted() {
    this.selectedFilter = this._.clone(this.defaultFilter);
    this.addedFilters = this.value;
  },
  computed: {
    selectFilters() {
      return this.filters
        .filter((filter) => this.addedFilters[filter.name] === undefined)
        .map((filter) => {
          return { text: filter.label, value: filter.name };
        });
    },
    filterName: {
      get() {
        return this.selectedFilter.name;
      },
      set(value) {
        const filter = this.filters.find((f) => f.name === value);
        this.selectedFilter.name = filter.name;
        this.selectedFilter.label = filter.label;
        this.selectedFilter.type = filter.type;
        this.selectedFilter.options = filter.options || {};
        this.selectedFilter.value = filter.defaultValue;
        this.selectedFilter.multiple = filter.multiple;
      },
    },
    valueErrors() {
      const errors = [];
      if (!this.$v.selectedFilter.value.$dirty) return errors;
      !this.$v.selectedFilter.value.numeric && errors.push("Apenas números");
      return errors;
    },
  },
  methods: {
    close() {
      this.menu = false;
      this.selectedFilter = this._.clone(this.defaultFilter);
    },
    addFilter() {
      this.$set(
        this.addedFilters,
        this.selectedFilter.name,
        this.selectedFilter.value
      );
      this.close();
      this.$emit("input", this.addedFilters);
    },
    clearFilters() {
      this.addedFilters = {};
      this.close();
      this.$emit("input", this.addedFilters);
    },
    removeFilter(name) {
      this.$delete(this.addedFilters, name);
    },
    chipLabel(name) {
      return this.filters.find((filter) => filter.name === name).label;
    },
    chipValue(name, value) {
      const filter = this.filters.find((f) => f.name === name);
      if (filter) {
        switch (filter.type) {
          case "number":
          case "text":
            return value;
          case "switch":
            return value
              ? filter.options.trueValue || "Sim"
              : filter.options.falseValue || "Não";
          case "select":
            if (!filter.options || filter.options.length === 0) {
              return "...";
            }
            if (filter.multiple) {
              return value
                .map((v) => filter.options.find((o) => o.value === v).text)
                .join(", ");
            }
            return filter.options.find((o) => o.value === value).text;
        }
      }
      return "";
    },
    customFilter(item, queryText, itemText) {
      return (
        itemText
          .normalize("NFKD")
          .replace(/[\u0300-\u036f]/g, "")
          .toUpperCase()
          .indexOf(
            queryText
              .normalize("NFKD")
              .replace(/[\u0300-\u036f]/g, "")
              .toUpperCase()
          ) > -1
      );
    },
  },
};
</script>

<style scoped>
.datatable-filters {
  margin-left: -12px;
}
</style>
